import { FilterComponentDate } from './SingleFilterTypes/_Type@dateRange/FilterComponentsDate'
import { FilterComponentOptions } from './SingleFilterTypes/_Type@options/FilterComponentOptions'
import { FilterComponentInput } from './SingleFilterTypes/_Type@string/FilterComponentString'

export const SUPPORT_TYPE_PROPERTY_GID = 'a4a564cf-4d38-4e5f-8ce7-1e364cf7c3ab'
export const FILTER_COMPONENT_TYPE = {
  options: FilterComponentOptions,
  string: FilterComponentInput,
  dateRange: FilterComponentDate,
}

export const PINNED_FILTERS = 'pfndlsrs'
